import { NodeTypeName } from "@app/types";
import {
    BannerNodeModel,
    BaseLinkModel,
    BaseNodeModel,
    BeginNodeModel,
    ConditionNodeModel,
    CustomNodeModel,
    DataAccessCompletionNodeModel,
    DataNodeModel,
    DtmfNodeModel,
    ExitNodeModel,
    FlushPromptsNodeModel,
    HumanAssistedResolutionNodeModel,
    InputNodeModel,
    IntentDataModel,
    LoopEscalationNodeModel,
    ModuleNodeModel,
    ModuleReferenceNodeModel,
    NoteNodeModel,
    OasysNodeModel,
    PlaySavedPromptNodeModel,
    PromptNodeModel,
    PromptReferenceNodeModel,
    ReportNodeModel,
    RichTextNodeModel,
    SavePromptNodeModel,
    SessionCompletionNodeModel,
    SessionNodeModel,
    TabNodeModel,
    TaskOrchestrationNodeModel,
    TrustedResponseNodeModel,
    WithFillerNodeModel
} from "../models";

// Registry for dynamic node instantiation
// !!! Dont forget to add reserved name to webpack prod config !!!
// Set `props.iconClass` on models that extend `BaseNodeModel` and add the rest to `getModelIcon`.
// Update updateParentNode function in AppManager
const register = {
    // Backward compatibility for Amelia → OASYS rename
    AmeliaNodeModel: OasysNodeModel,
    BannerNodeModel,
    BaseLinkModel,
    BaseNodeModel,
    BeginNodeModel,
    ConditionNodeModel,
    CustomNodeModel,
    DataAccessCompletionNodeModel,
    DataNodeModel,
    DtmfNodeModel,
    ExitNodeModel,
    FlushPromptsNodeModel,
    HumanAssistedResolutionNodeModel,
    InputNodeModel,
    IntentDataModel,
    LoopEscalationNodeModel,
    ModuleNodeModel,
    ModuleReferenceNodeModel,
    NoteNodeModel,
    OasysNodeModel,
    PlaySavedPromptNodeModel,
    PromptNodeModel,
    PromptReferenceNodeModel,
    ReportNodeModel,
    RichTextNodeModel,
    SavePromptNodeModel,
    SessionCompletionNodeModel,
    SessionNodeModel,
    TabNodeModel,
    TaskOrchestrationNodeModel,
    TrustedResponseNodeModel,
    // Backward compatibility between VXMLRenderNodeModel <-> FlushPromptsNodeModel
    VXMLRenderNodeModel: FlushPromptsNodeModel,
    WithFillerNodeModel
};

const registerNodeTypeName = {
    // Backward compatibility for Amelia → OASYS rename
    Amelia: OasysNodeModel,
    [NodeTypeName.banner]: BannerNodeModel,
    [NodeTypeName.base]: BaseNodeModel,
    [NodeTypeName.begin]: BeginNodeModel,
    [NodeTypeName.condition]: ConditionNodeModel,
    [NodeTypeName.custom]: CustomNodeModel,
    [NodeTypeName.data]: DataNodeModel,
    [NodeTypeName.dataAccessCompletion]: DataAccessCompletionNodeModel,
    [NodeTypeName.dtmfMenu]: DtmfNodeModel,
    [NodeTypeName.exit]: ExitNodeModel,
    [NodeTypeName.flushPrompts]: FlushPromptsNodeModel,
    [NodeTypeName.humanAssistedResolution]: HumanAssistedResolutionNodeModel,
    [NodeTypeName.input]: InputNodeModel,
    [NodeTypeName.intent]: IntentDataModel,
    [NodeTypeName.link]: BaseLinkModel,
    [NodeTypeName.loopEscalation]: LoopEscalationNodeModel,
    [NodeTypeName.module]: ModuleNodeModel,
    [NodeTypeName.moduleReference]: ModuleReferenceNodeModel,
    [NodeTypeName.note]: NoteNodeModel,
    [NodeTypeName.oasys]: OasysNodeModel,
    [NodeTypeName.playSavedPrompt]: PlaySavedPromptNodeModel,
    [NodeTypeName.prompt]: PromptNodeModel,
    [NodeTypeName.promptReference]: PromptReferenceNodeModel,
    [NodeTypeName.report]: ReportNodeModel,
    [NodeTypeName.richText]: RichTextNodeModel,
    [NodeTypeName.savePrompt]: SavePromptNodeModel,
    [NodeTypeName.session]: SessionNodeModel,
    [NodeTypeName.sessionCompletion]: SessionCompletionNodeModel,
    [NodeTypeName.tab]: TabNodeModel,
    [NodeTypeName.taskOrchestration]: TaskOrchestrationNodeModel,
    [NodeTypeName.trustedResponse]: TrustedResponseNodeModel,
    [NodeTypeName.withFiller]: WithFillerNodeModel
};

export default class NodeRegistry {

    /**
     * Node dynamic instantiation
     * @module NodeRegistry
     */
    static get r() {
        return register;
    }

    /**
     * Node dynamic instantiation
     * @module NodeRegistry
     */
    static get rn() {
        return registerNodeTypeName;
    }

    /**
     * Construct a new Node using NodeRegistry
     * @param target
     * @param source
     */
    static buildNode(element) {
        const { _class, props: { nodeTypeName } } = element;
        let nodeClass = null;
        if (_class in register) {
            nodeClass = register[_class];
        } else if (nodeTypeName in registerNodeTypeName) {
            nodeClass = registerNodeTypeName[nodeTypeName];
        } else {
            throw new Error(`buildNode: Unable to find _class "${_class}" & nodeTypeName: "${nodeTypeName}".`);
        }

        if (nodeClass == null) {
            throw new Error('buildNode: nodeClass is null, this usually happens due to circular imports.');
        }

        return new nodeClass(element.name, element.x, element.y, element.props, element.id);
    }
}
